import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f16fccc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  title: "Required Field"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" - Optional field")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("abbr", null, "*", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["name", "placeholder", "maxlength", "pattern", "multiple", "autofocus", "disabled", "readonly", "required"]
const _hoisted_7 = {
  key: 2,
  class: "conditions"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Has account name consisting of alphabets and/or numbers and/or special characters(%.-+_). ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Has a domain name consisting of alphabets, numbersm . and -. Ex: @google, @yahoo, @facebook etc. ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Ends with a 2-3 character To plevel domain (TLD). Ex: .net, .com, .edu, .co etc... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_response = _resolveComponent("input-response")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["emailInput", { inline: _ctx.inline }])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass({ maskField: _ctx.mask })
        }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.isRequired)
            ? (_openBlock(), _createElementBlock("abbr", _hoisted_1, "*"))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_5))
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({
				warningContainer: _ctx.alertMessage ? _ctx.alertMessage.warning : false,
				errorContainer: _ctx.alertMessage ? _ctx.alertMessage.error : false,
				iconPadding: _ctx.icon,
				maskField: _ctx.mask
			})
    }, [
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(_ctx.icon)
          }, null, 2))
        : _createCommentVNode("", true),
      (!_ctx.mask)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dValue) = $event)),
            type: "email",
            name: _ctx.name,
            placeholder: _ctx.placeholder,
            maxlength: _ctx.maxlength,
            pattern: _ctx.pattern,
            multiple: _ctx.multiple,
            autofocus: _ctx.autofocus,
            disabled: _ctx.isDisabled,
            readonly: _ctx.isReadOnly,
            required: _ctx.isRequired,
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
            onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.followsPattern && _ctx.followsPattern(...args)))
          }, null, 40, _hoisted_6)), [
            [_vModelText, _ctx.dValue]
          ])
        : _createCommentVNode("", true),
      (_ctx.dValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                class: _normalizeClass(
							_ctx.dValue.match(/^[A-Za-z0-9._%+-]/g)
								? 'fas fa-check'
								: 'fas fa-times'
						)
              }, null, 2),
              _hoisted_8
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                class: _normalizeClass(
							_ctx.dValue.match(/(?=@[A-Za-z0-9.-])/g)
								? 'fas fa-check'
								: 'fas fa-times'
						)
              }, null, 2),
              _hoisted_9
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                class: _normalizeClass(
							_ctx.dValue.match(/(?=.[A-Za-z]{2,3}$)/)
								? 'fas fa-check'
								: 'fas fa-times'
						)
              }, null, 2),
              _hoisted_10
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_input_response, {
      warning: _ctx.alertMessage ? _ctx.alertMessage.warning : '',
      error: _ctx.alertMessage ? _ctx.alertMessage.error : '',
      "char-limit-reached": _ctx.dValue ? _ctx.maxlength - _ctx.dValue.length < 0 : false,
      maxlength: _ctx.maxlength
    }, null, 8, ["warning", "error", "char-limit-reached", "maxlength"])
  ], 2))
}